import Ingest from "./Ingest";

export default {
  Ingest
};
